export default __webpack_public_path__ + "static/media/FlatGenericAllFullSize.8ac318db.jpg";